import React, {Component, PropTypes} from 'react'
import Radium, {keyframes} from 'radium'
import FileSaver from 'file-saver'
import ClipboardJS from 'clipboard'
import removeIcon from './checkmark.svg'
import addIcon from './checkmark2.svg'
import imageIcon from './image.svg'
import downloadIcon from './download.svg'

@Radium
export default class SymbolList extends Component {
  static propTypes = {
    symbols: PropTypes.array.isRequired
  }

  constructor () {
    super()
    this.symbolIdInputs = []
    this.state = {
      symbols: []
    }
  }

  componentDidMount () {
    this.clipboard = new ClipboardJS('[data-clipboard-symbol-id]', {
      text: trigger => {
        let symbol = this.props.symbols[trigger.dataset.clipboardSymbolId]
        return symbol.bgString
      }
    })
  }

  componentWillUnmount () {
    this.clipboard.destroy()
  }

  countSymbols = (state) => {
    return this.props.symbols.filter(symbol => symbol.include === state).length
  }

  handleOnChange = (index, event) => {
    this.props.symbols[index].id = event.target.value
    this.setState({
      symbols: this.props.symbols
    })
  }

  handleOnClick = (index, action, event) => {
    if (action === 'toggle') {
      this.props.symbols[index].include = !this.props.symbols[index].include // Toggle include state

      this.setState({
        symbols: this.props.symbols
      })
    } else if (action === 'download') {
      let icon = this.props.symbols[index]
      let fileContent = `<svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="${icon.viewBox}">${icon.content}</svg>`

      let file = new File([fileContent], `${icon.id}.svg`, {type: 'image/svg+xml;charset=utf-8'})
      FileSaver.saveAs(file)
    }
  }

  render () {
    const totalNum = this.props.symbols.length
    const includedNum = this.countSymbols(true)
    const excludedNum = this.countSymbols(false)

    return (
      <div>
        {totalNum > 0 &&
          <p style={styles.stats}>{totalNum} ikoner totalt / {includedNum} inkluderade / {excludedNum} exkluderade</p>
        }
        <ol style={styles.container}>
          {this.props.symbols.map((symbol, index) => (
            <li style={[styles.item, {animationDelay: `${index * 0.02}s`}]} key={index}>
              <figure style={styles.figure}>
                <svg style={[styles.symbol.base, symbol.include ? styles.symbol.stateInclude : styles.symbol.stateExclude]} viewBox={symbol.viewBox} dangerouslySetInnerHTML={{__html: symbol.content}} version='1.1' xmlns='http://www.w3.org/2000/svg' />

                <button style={styles.toggleButton} onClick={event => this.handleOnClick(index, 'toggle', event)} aria-label=''>
                  <img style={styles.contextButtonIcon} src={symbol.include ? removeIcon : addIcon} alt='' />
                </button>

                <button data-clipboard-symbol-id={index} style={styles.backgroundButton} title='Kopiera som CSS' aria-label=''>
                  <img style={styles.contextButtonIcon} src={imageIcon} alt='' />
                </button>

                <button style={styles.downloadButton} onClick={event => this.handleOnClick(index, 'download', event)} title='Ladda ner' aria-label=''>
                  <img style={styles.contextButtonIcon} src={downloadIcon} alt='' />
                </button>
              </figure>

              <input type='text' onChange={event => this.handleOnChange(index, event)} style={styles.symbolId} value={symbol.id} />
            </li>
          ))}
        </ol>
      </div>
    )
  }
}

const entryKeyframes = keyframes({
  from: {
    opacity: 0,
    transform: 'scale(.8)'
  }
})

const gridSize = 8
const gridColor = '#ccc'
const gradient = `linear-gradient(45deg, ${gridColor} 25%, transparent 25%, transparent 75%, ${gridColor} 75%, ${gridColor} 100%)`

const styles = {
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    margin: 0,
    padding: '.75em',
    textAlign: 'center'
  },
  stats: {
    textAlign: 'center'
  },
  item: {
    display: 'block',
    flex: '1 0 auto',
    margin: '.75em',
    animationName: entryKeyframes,
    animationDuration: '.1s',
    animationFillMode: 'backwards',
    maxWidth: '200px',
    minWidth: '150px'
  },
  figure: {
    margin: '0 auto',
    maxWidth: '8em',
    position: 'relative'
  },
  toggleButton: {
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    border: 0,
    borderRadius: '3px',
    cursor: 'pointer',
    padding: '5px',
    position: 'absolute',
    top: '-15px',
    right: '-15px'
  },
  backgroundButton: {
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    border: 0,
    borderRadius: '3px',
    cursor: 'pointer',
    padding: '5px',
    position: 'absolute',
    top: '20px',
    right: '-15px'
  },
  downloadButton: {
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    border: 0,
    borderRadius: '3px',
    cursor: 'pointer',
    padding: '5px',
    position: 'absolute',
    top: '55px',
    right: '-15px'
  },
  contextButtonIcon: {
    height: '20px',
    verticalAlign: 'middle',
    width: '20px'
  },
  symbol: {
    base: {
      width: '8em',
      height: '8em',
      strokeWidth: 0,
      stroke: 'black',
      fill: 'black',
      backgroundColor: 'white',
      backgroundImage: `${gradient}, ${gradient}`,
      backgroundSize: `${gridSize * 2}px ${gridSize * 2}px`,
      backgroundPosition: `0 0, ${gridSize}px ${gridSize}px`,
      boxShadow: `0 .1em .4em rgba(0, 0, 0, .2)`
    },
    stateInclude: {},
    stateExclude: {
      opacity: 0.2
    }
  },
  symbolId: {
    background: 'transparent',
    borderLeft: 0,
    borderRight: 0,
    borderTop: 0,
    borderBottom: '1px solid #000',
    boxSizing: 'border-box',
    color: '#fff',
    display: 'block',
    fontSize: '.9em',
    fontWeight: 700,
    marginTop: '.1em',
    padding: '.3em',
    width: '100%'
  }
}



// WEBPACK FOOTER //
// src/components/symbol-list/index.js